import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import "../styles/windParkPage.css";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import NotificationsPausedIcon from "@mui/icons-material/NotificationsPaused";
import CheckIcon from "@mui/icons-material/Check";
import ListItemIcon from '@mui/material/ListItemIcon';
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { activateEquipmentMarineLanterns, activateEquipmentNarineHelicopterCorridorLights, activateEquipmentVisibilitySensor, displayHelicopterCorridorLights, displayMarineLanterns, displayVisibilitySensor, inActivateEquipmentMarineLanterns, inActivateEquipmentNarineHelicopterCorridorLights, inActivateEquipmentVisibilitySensor } from "../../../features/WTG/TurbineSlice";


import AIS_Monitor from "../../../images/SCADA/AIS_Monitor.svg";
import AviationObstructionLight from "../../../images/SCADA/AviationObstructionLight.svg";
import Foghorn from "../../../images/SCADA/Foghorn.svg";
import HelicopterCorridorLight from "../../../images/SCADA/HelicopterCorridorLight.svg";
import HeliHoistLight from "../../../images/SCADA/HeliHoistLight.svg";
import ID_Sign from "../../../images/SCADA/ID_Sign.svg";
import LED_FloodLight from "../../../images/SCADA/LED_FloodLight.svg";
import MarineLantern from "../../../images/SCADA/MarineLantern.svg";
import MRASS from "../../../images/SCADA/MRASS.svg";
import Photocell from "../../../images/SCADA/Photocell.svg";
import TowerLights from "../../../images/SCADA/TowerLights.svg";
import VisibilitySensor from "../../../images/SCADA/VisibilitySensor.svg";


const PaperColor="#37474f";








export function ListItemRows(WindTurbine) {
    const dispatch = useDispatch()
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(!open)
        dispatch(displayHelicopterCorridorLights(0))
        dispatch(displayVisibilitySensor(0))
        dispatch(displayMarineLanterns(0))
    }

    return (
        <div>
            <ListItemButton onClick={() => handleOpen() }>
                <ListItemText
                    primary="Wind Turbine Specification"
                    primaryTypographyProps={{
                        color: "white",
                        fontWeight: 550,
                        variant: "body1",
                    }}
                ></ListItemText>
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                   
                    disablePadding
                    sx={{  bgcolor: PaperColor }}
                
                >
                    {/* <ListSubheader
              component="div"
              id="nested-list-subheader"
              sx={{ margin: 0 }}
            >
              <p className="turbineTableSubHeader2">Aviation System </p>
            </ListSubheader>
            <Divider />
            {DispolayTurbineSpecification(WTS_AviationSystemList1)}
            <ListSubheader component="div" id="nested-list-subheader">
              <p className="turbineTableSubHeader2">OutSide on Tower</p>
            </ListSubheader>
            <Divider />
  
            {DispolayTurbineSpecification(WTS_OutSideOnTowerList1)} */}

                    <ListSubheader sx={{bgcolor: PaperColor, color:"white"}} component="div" id="nested-list-subheader">
                        <p className="turbineTableSubHeader2" style={{color:"white", size:"20px"}} fontSize={"15"}  >Aviation Aid Equipment</p>
                    </ListSubheader>
                    <Divider />
                    {DispolayTurbineSpecificationNacelle(WindTurbine)}
                    <ListSubheader sx={{bgcolor: PaperColor, color:"white"}} component="div" id="nested-list-subheader">
                        <p className="turbineTableSubHeader2" style={{color:"white", fontSize:"15"}} >Tower Aid Equipment</p>
                    </ListSubheader>
                    <Divider />
                    {DispolayTurbineSpecificationTower(WindTurbine)}
                    <ListSubheader sx={{bgcolor: PaperColor, color:"white"}} component="div" id="nested-list-subheader">
                        <p className="turbineTableSubHeader2" style={{color:"white", fontSize:"15"}} >Marine Aid Equipment</p>
                    </ListSubheader>
                    <Divider />
                    {DispolayTurbineSpecification(WindTurbine)}
                </List>
            </Collapse>
            {ListItemRows2(WindTurbine)}
        </div>
    );
}


function ListItemRows2(WindTurbine) {
    const [open, setOpen] = React.useState(false);
    return (
        <div>
            <ListItemButton onClick={() => setOpen(!open)}>
                <ListItemText
                    primary="Wind Turbine Oil Sensor"
                    primaryTypographyProps={{
                        color: "white",
                        fontWeight: 550,
                        variant: "body1",
                    }}
                ></ListItemText>
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                   
                    disablePadding
                    sx={{  bgcolor: PaperColor }}
                
                >
                    <Divider />
        
                    <ListItemButton >
                        <a href="/oilsensor" style={{textDecoration: "none"}}>

                        <p className="turbineTableSubHeader2" style={{color:"white", size:"12px"}} fontSize={"12"}  >Manage Oil Data</p>
                        </a>
                     </ListItemButton>
                    <Divider />
    
                </List>
            </Collapse>
        </div>
    );
}



 

function DispolayTurbineSpecificationNacelle(WindTurbine, Disable) {

    //   return WindTurbine.wtg.equipment.map(function (specification, idx) {
    //     return DivDisplay(specification, Disable, idx);

    //   });

    const ListItems = [];
    for (const [key, value] of Object.entries(WindTurbine.wtg.equipment)) {
        //Check if it exists
        if(key ==="visibilitySensor" && value.amount )
        {
            ListItems.push(DivDisplay(key, value))
        }
    }

    // Addiitonal elemts for display only


        //NACELLE
        //VISIBILITY SENSOR 
        ListItems.push(ListDiv("AIS monitor",AIS_Monitor,true))
        ListItems.push(ListDiv("Aviation Obstruction light",AviationObstructionLight,true))
        ListItems.push(ListDiv("Heli Hoist Light ",HeliHoistLight,true))



    return ListItems;

}

function DispolayTurbineSpecificationTower(WindTurbine, Disable) {

    //   return WindTurbine.wtg.equipment.map(function (specification, idx) {
    //     return DivDisplay(specification, Disable, idx);

    //   });

    const ListItems = [];
    
    // Addiitonal elemts for display only


            // TOWER
            ListItems.push(ListDiv("Tower lights",TowerLights,true))



    return ListItems;

}

function DispolayTurbineSpecification(WindTurbine, Disable) {

    //   return WindTurbine.wtg.equipment.map(function (specification, idx) {
    //     return DivDisplay(specification, Disable, idx);

    //   });
    const ListItems = [];
    for (const [key, value] of Object.entries(WindTurbine.wtg.equipment)) {
        //Check if it exists
        if(key ==="marineLanterns" && value.amount || key ==="marineHelicopterCorridorLights" && value.amount)
        {
            ListItems.push(DivDisplay(key, value))
        }
    }


    // Addiitonal elemts for display only
// ListItem.push(DivDisplay(NameObjects[1]))

// //NACELLE
// //VISIBILITY SENSOR 
// ListItems.push(ListDiv("AIS monitor",AIS_Monitor,true))
// ListItems.push(ListDiv("Aviation Obstruction light",AviationObstructionLight,true))
// ListItems.push(ListDiv("Heli Hoist Light ",HeliHoistLight,true))
// // TOWER
// ListItems.push(ListDiv("Tower lights",TowerLights,true))

    //Marine
    
    //MARINE LANTERN
    //HelicopterCorridorLights
    ListItems.push(ListDiv("LED Floodlight",LED_FloodLight, true))
    // NOT
    ListItems.push(ListDiv("Foghorn",Foghorn, false))
    ListItems.push(ListDiv("Photocell",Photocell, false))
    ListItems.push(ListDiv("ID Sign",ID_Sign,false))
    ListItems.push(ListDiv("MRASS",MRASS,false))


    //
 


// Not adjustable


    return ListItems;

}

const NameObjects = {
    "marineHelicopterCorridorLights": {
        name:"Marine Helicopter Corridor Lights",
        icon: HelicopterCorridorLight},


    "visibilitySensor":{
        name:"Visibility Sensor",
        icon: VisibilitySensor},
        
    "marineLanterns": {
        name:"Marine Lanterns",
        icon: MarineLantern
    },
}
// HeliHoistLight:" Heli Hoist Light",

// VisibilitySensor: "Visibility Sensor",

// AviationObstru:"",


function ListDiv(Name, icon, activate,idx){
    
    const [Label, setLabel] = React.useState("Active");
    const [isChecked, setChecked] = React.useState(true);


    const handleChange = (e) => {
        Label === "Active" ? setLabel("Inactive") : setLabel("Active");
        Label === "Active" ? setChecked(false) : setChecked(true);
    }
    return (
    <div >
    <ListItemButton key={idx}sx={{ margin: -.8 }}>

          <img src={icon} alt="logo" width={"35px"} />
        <ListItemText
        sx={{pl:1.5}}
            primary={Name}
            primaryTypographyProps={{
                color: "white",
                fontWeight: "medium",
                variant: "body2",
                fontSize: 14,
            }}
            />
{activate?
        <FormControlLabel
 
        value="Inactive"
        control={

                <Switch
                {...Label}
                checked={isChecked}
                size={"small"}
                onChange={handleChange}
                sx={{marginRight:"20px"}}
                />}

            label={Label}
            labelPlacement="start"
            style={{color:"white"}}          
            ></FormControlLabel>
            :
            null
        }
    </ListItemButton>
    <Divider />
</div>

    )
}

function DivDisplay(key, value, Disable, idx, activate) {
    const dispatch = useDispatch()

    const [Label, setLabel] = React.useState(value.state ? "Inactive" : "Active");
    const [isChecked, setChecked] = React.useState(value.state ? false : true);


    let Icon = null;
    let Name = null;
    for (const [objectName, object] of Object.entries(NameObjects)) {
        if (objectName === key) {
            Name = object.name;
            Icon = object.icon;
            activate = true;
        }
    }

    const handleChange = (e) => {
        Label === "Active" ? setLabel("Inactive") : setLabel("Active");
        Label === "Active" ? setChecked(false) : setChecked(true);

        if (key === "marineHelicopterCorridorLights") {
            Label === "Active" ? dispatch(inActivateEquipmentNarineHelicopterCorridorLights()) : dispatch(activateEquipmentNarineHelicopterCorridorLights())
        }
        else if (key === "visibilitySensor") {
            Label === "Active" ? dispatch(inActivateEquipmentVisibilitySensor()) : dispatch(activateEquipmentVisibilitySensor())

        } else if (key === "marineLanterns") {
            Label === "Active" ? dispatch(inActivateEquipmentMarineLanterns()) : dispatch(activateEquipmentMarineLanterns())
        }

    };

    const handleClick = (e) => {
        var action = 1;
        if( Label ==="Active"){
            action =0;
        }
        if (key === "marineHelicopterCorridorLights") {
            dispatch(displayHelicopterCorridorLights(action))
        }
        else if (key === "visibilitySensor") {
            dispatch(displayVisibilitySensor(action))

        } else if (key === "marineLanterns") {
            dispatch(displayMarineLanterns(action)) 
        }
    }

    return value.amount ? (
        <div key={idx}>
            <ListItemButton onClick={() => handleClick()} sx={{ margin: -0.8 }}>
            <img src={Icon} alt="logo" width={"35px"} />
                <ListItemText
                    sx={{pl:1.5}}
                    primary={Name}
                    primaryTypographyProps={{
                        color: "white",
                        fontWeight: "medium",
                        variant: "body2",
                        fontSize: 14,
                    }}
                />
                {activate? 
                <FormControlLabel
                value="Inactive"
                control={
                    <Switch
                    sx={{marginRight:"20px"}}
                            {...Label}
                            checked={isChecked}
                            size={"small"}
                            disabled={Disable}
                            onChange={handleChange}
                            />
                    }
                    label={Label}
                    labelPlacement="start"
                    style={{color:"white"}}
                    
                    ></FormControlLabel>
                    :
                    null
                }
            </ListItemButton>
            <Divider />
            </div>
    ) :
        null;
}
